import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DialogService } from '../../../../services/dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { DatePipe } from '@angular/common'
import { Utils } from '../../../../utils/utils';


@Component({
    selector: 'functionsconfigpopup',
    templateUrl: './functionsconfigpopup.component.html',
    styleUrls: ['../../../../style/custom-mat-dialog.component.less'],
    standalone: false
})


export class FunctionsConfigPopupComponent implements OnInit {

    body: any;

    submitted = false;
    form: FormGroup

    constructor(private http: HttpClient
        , private confimDialog: DialogService
        , private router: Router
        , @Inject(MAT_DIALOG_DATA) public data: any
        , @Inject('BASE_URL') private baseUrl: string
        , public dialogRef: MatDialogRef<FunctionsConfigPopupComponent>
        , private fb: FormBuilder
        , public defaults: DefaultValuesService
        , private formBuilder: FormBuilder
        , private datepipe: DatePipe) {

        this.confimDialog.tthis = this;
        this.form = this.formBuilder.group({})
    }

    ngOnInit(): void {
        this.body = {
            Argument: this.data.argument ? this.data.argument : '',
            FunctionConfigParameterId: this.data.functionParameterId ? this.data.functionParameterId : null,
            FunctionKey: this.data.functionKey,
            DisplayName: this.data.displayName
        }
        this.form = this.formBuilder.group({
            argument: ['', [Validators.required]],
            displayName: [''],
        });
    }
    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }
        Utils.httpUpdateFunctionConfigParameter(
            this.http
            , this.baseUrl
            , this.body
            , this
            , function (tthis: FunctionsConfigPopupComponent, object: any) {
                tthis.dialogRef.close();
            }
        );
    }

    onBack() {

    }
}


